export class Debug {
  static assert(condition: boolean, msg: string): asserts condition {
    if (!condition) throw new Error(msg);
  }

  static notNull<T>(obj: T | null | undefined): asserts obj {
    if (!obj) throw new Error("Object is null!");
  }

  static notSupported(msg?: string): void {
    throw new Error("Not supported: " + msg);
  }

  static notHandled(msg?: string): void {
    throw new Error("Not handled: " + msg);
  }

}
